import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=0f8e5b26&"
import script from "./MasterPage.vue?vue&type=script&lang=ts&"
export * from "./MasterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports